import { useEffect, useRef, useState } from "react";
import { useStore } from "../root-store-context";
import { GENERIC_MESSAGE } from "../api/Report";

export const useReportEmbedUrl = (reportId: string) => {
    const { reportStore, applicationStore: { SelectedAddress } } = useStore();

    const [reportUrl, setReportUrl] = useState<string>("");
    const [isLoadReport, setIsLoadReport] = useState<boolean>(true);
    const [loadError, setLoadError] = useState<string | null>(null);
    const lastUsedSourceCommunityId = useRef<string | null>(null);

    useEffect(() => {
        const currentSourceCommunityId = SelectedAddress?.communityId;

        if (!currentSourceCommunityId) return;
        if (currentSourceCommunityId === lastUsedSourceCommunityId.current) return;

        lastUsedSourceCommunityId.current = currentSourceCommunityId;
        setIsLoadReport(true);
        setLoadError(null);

        let cancelled = false;
        (async () => {
            try {
                const res = await reportStore.getEmbedUrl(reportId, currentSourceCommunityId);
                if (cancelled) return;
                if (res.isSuccess) {
                    setReportUrl(res.url);
                } else {
                    setReportUrl("");
                    setLoadError(res.message);
                }
            } catch {
                if (cancelled) return;
                setReportUrl("");
                setLoadError(GENERIC_MESSAGE);
            } finally {
                if (!cancelled) setIsLoadReport(false);
            }
        })();

        return () => {
            cancelled = true;
            // React StrictMode runs effects twice in development: mount, clean up, mount again.
            // The guard ref is set before the await, so without rolling it back here the second
            // run short-circuits while the first run's result is discarded as cancelled - the
            // iframe keeps an empty src and the spinner never stops.
            if (lastUsedSourceCommunityId.current === currentSourceCommunityId) {
                lastUsedSourceCommunityId.current = null;
            }
        };
    }, [SelectedAddress?.communityId, reportId, reportStore]);

    return { reportUrl, isLoadReport, loadError };
};

export default useReportEmbedUrl;
